module.exports = __webpack_public_path__ + "img/daikin-logo.14fd18a2.png";